import { writable } from "svelte/store";

const FILL_WIDTH_STORAGE_KEY = "parkito-full_width";
function loadFillWidthFromStore(): boolean {
  let stored = window.localStorage.getItem(FILL_WIDTH_STORAGE_KEY);
  if (stored) {
    return stored === "true";
  } else {
    window.localStorage.setItem(FILL_WIDTH_STORAGE_KEY, "false");
    return false;
  }
}

function setupFillWidthStore() {
  const value = loadFillWidthFromStore();
  const { subscribe, set } = writable<boolean>(value);

  return {
    subscribe,
    setValue: (b: boolean) => {
      let res = window.localStorage.setItem(
        FILL_WIDTH_STORAGE_KEY,
        b.toString(),
      );
      set(b);
    },
  };
}

export const fillWidth = setupFillWidthStore();
